import axiosHttp from '../hooks/intercepter';
import { store } from '../redux/store';
import { setSidebarMenu, setSidebarLoading, setSidebarError } from '../redux/sidebarSlice';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const updateSettings = async (userId, settingsData) => {
    return await axiosHttp.put(`${BASE_URL}/users/${userId}/settings`, settingsData);
};

const getSettings = async (catererId) => {
    return await axiosHttp.get(`${BASE_URL}/settings/${catererId}`);
};

const createSettings = async (settingsData) => {
    return await axiosHttp.post(`${BASE_URL}/settings`, settingsData);
};

const getAllsidemenu = async () => {
    return await axiosHttp.get(`${BASE_URL}/sidebar-menu`);
};

// New function to fetch sidebar menu and store in Redux
export const fetchSidebarMenu = async () => {
    try {
        store.dispatch(setSidebarLoading(true));
        const response = await getAllsidemenu();
        
        if (response.data && response.data.success) {
            store.dispatch(setSidebarMenu(response.data.data));
            return response.data.data;
        } else {
            store.dispatch(setSidebarError('Failed to fetch sidebar menu'));
            return null;
        }
    } catch (error) {
        console.error('Error fetching sidebar menu:', error);
        store.dispatch(setSidebarError(error.message || 'Error fetching sidebar menu'));
        return null;
    }
};

export { updateSettings, getSettings, createSettings, getAllsidemenu }; 
